import { render } from "./LicenseRoute.vue?vue&type=template&id=50c2aff4"
import script from "./LicenseRoute.vue?vue&type=script&lang=js"
export * from "./LicenseRoute.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__